import { forwardRef, Ref } from 'react'

import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'

interface Props {
  className?: string
  checked: boolean
  label: string
  name?: string
  onValueChange: (value: boolean) => void
  disabled?: boolean
}

const LabeledInputSwitch = forwardRef((props: Props, ref: Ref<HTMLButtonElement>) => {
  const { checked, onValueChange, name, label, className, disabled } = props
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Switch
        className="flex-none"
        checked={checked}
        onCheckedChange={onValueChange}
        id={name}
        ref={ref}
        disabled={disabled}
      />
      <label htmlFor={name} className="cursor-pointer">
        {label}
      </label>
    </div>
  )
})

export default LabeledInputSwitch
